var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_22_2",
    "data-name": "Component 22 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9D78",
    id: "Path_75",
    "data-name": "Path 75",
    d: "M46.62,69.28a.689.689,0,0,0,.685-.684V62.5a.684.684,0,0,0-1.369,0v6.1A.689.689,0,0,0,46.62,69.28Z",
    transform: "translate(-35 -47.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9D78",
    id: "Path_76",
    "data-name": "Path 76",
    d: "M53.4,69.28a.688.688,0,0,0,.684-.684V62.5a.684.684,0,0,0-1.368,0v6.1A.688.688,0,0,0,53.4,69.28Z",
    transform: "translate(-35 -47.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9D78",
    id: "Path_77",
    "data-name": "Path 77",
    d: "M50,69.28a.688.688,0,0,0,.684-.684V62.5a.684.684,0,0,0-1.368,0v6.1A.688.688,0,0,0,50,69.28Z",
    transform: "translate(-35 -47.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9D78",
    id: "Path_78",
    "data-name": "Path 78",
    d: "M50,47.5a15,15,0,1,0,15,15A15,15,0,0,0,50,47.5Zm6.887,23.941A1.349,1.349,0,0,1,55.54,72.66H44.46a1.332,1.332,0,0,1-1.347-1.219L41.872,58.436H58.128Zm1.241-14.374H41.872a1.347,1.347,0,1,1,0-2.695h5.433v-.685a1.342,1.342,0,0,1,1.347-1.347h2.717a1.342,1.342,0,0,1,1.348,1.347v.685h5.411a1.347,1.347,0,1,1,0,2.695Z",
    transform: "translate(-35 -47.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRemove);
export default __webpack_public_path__ + "static/media/ico-remove.94d95215.svg";
export { ForwardRef as ReactComponent };